/**
 * Zielgröße des Zuschnitts (ImageCropper): Ausschnitt in Originalpixeln,
 * längste Kante höchstens `maxKante`.
 *
 * Früher wurde zusätzlich mit dem Pixelfaktor des Geräts multipliziert (am
 * Handy ×3) — ein großer Plan sprengte so den Canvas-Speicher, ohne dass das
 * Bild schärfer wurde.
 */
export const MAX_KANTE_PX = 4096;

export function zielMasse(breite: number, hoehe: number, maxKante: number = MAX_KANTE_PX): { breite: number; hoehe: number } {
    const b = Math.max(1, Math.round(breite));
    const h = Math.max(1, Math.round(hoehe));
    const faktor = Math.min(1, maxKante / Math.max(b, h));
    return { breite: Math.max(1, Math.round(b * faktor)), hoehe: Math.max(1, Math.round(h * faktor)) };
}
